'use strict';

var formErrorsBase = require('base/checkout/formErrors');
var scrollAnimate = require('../components/scrollAnimate');
var focusHelper = require('../components/focus');

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 * @param {boolean} scroll - scroll to error or not
 */
formErrorsBase.loadFormErrors = function (parentSelector, fieldErrors, scroll) { // eslint-disable-line
    // Display error messages and highlight form fields with errors.
    $.each(fieldErrors, function (attr) {
        var $field = $('*[name=' + attr + ']', parentSelector);
        var $errorFeedback = $field.siblings('.invalid-feedback');

        // Generate a unique ID for the error message if it doesn't exist
        var errorId = 'error-' + attr.replace(/[[\].]/g, '-');
        $errorFeedback.attr('id', errorId);

        if (($errorFeedback.children().length === 0) || ($errorFeedback.css('display') === 'none')) {
            $field
            .addClass('is-invalid')
            .attr('aria-invalid', 'true');

            $errorFeedback
            .html(`<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>${fieldErrors[attr]}</span>`)
            .show();
        } else {
            $field
            .addClass('is-invalid')
            .attr('aria-invalid', 'true');
        }
    });

    // Find first invalid field - only select actual form fields (input, select, textarea), not containers
    var $firstInvalidField = $(parentSelector).find('input.is-invalid, select.is-invalid, textarea.is-invalid').first();

    var firstErrMsg = $firstInvalidField.siblings('.invalid-feedback').find('span').last().text();
    if (firstErrMsg && !window.pmAnnouncePending) {
        window.pmAnnouncePending = true;
        setTimeout(function () { window.pmAnnouncePending = null; }, 300);
        var $alertEl = $('<div>', { role: 'alert', 'aria-atomic': 'true' })
            .addClass('sr-only')
            .css('text-transform', 'none')
            .text(firstErrMsg);
        $('body').append($alertEl);
        setTimeout(function () { $alertEl.remove(); }, 1500);
    }

    // Animate to first input of form that has errors
    if (scroll !== false) {
        scrollAnimate($firstInvalidField);
    }

    // Set focus to the first field with an error
    if ($firstInvalidField.length > 0) {
        // Use focusWithPolling to ensure the field is focusable before attempting to focus
        focusHelper.focusWithPolling($firstInvalidField, {
            intervalMs: 50,
            maxAttempts: 10,
            ensureTabindex: false
        });
    }
};

/**
 * Clear the form errors and associated ARIA attributes.
 * @param {string} parentSelector - the parent form selector.
 */
formErrorsBase.clearPreviousErrors = function (parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').each(function () {
        $(this)
            .removeClass('is-invalid')
            .removeAttr('aria-invalid')
            .removeAttr('aria-describedby');
    });
    $('.error-message').hide();
};

module.exports = formErrorsBase;
